// extracted by mini-css-extract-plugin
module.exports = {"header":"-GMoAtMinemcpqUUxeG2eg==","text":"zWLd25Ui82xtwGeA8zj1SQ==","settingsContainer":"fVhb2rXBw0w-gFOgX5BBjA=="};